/**
 * Resolves an image path to a full URL.
 * Handles both relative paths (e.g., /uploads/offer/xxx.jpg) and absolute URLs.
 */
export const getImageUrl = (path) => {
  if (!path) return null;

  // If it's already a full URL (http://, https://, data:), use as-is
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) {
    return path;
  }

  // If it's a blob URL (local preview), use as-is
  if (path.startsWith('blob:')) {
    return path;
  }

  // For relative paths starting with /uploads, prepend the API base URL
  if (path.startsWith('/uploads/')) {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const baseUrl = apiUrl.replace(/\/api\/?$/, '');
    return `${baseUrl}${path}`;
  }

  // For bare filenames (no path separators), treat as /uploads/tours/<filename>
  // This is a fallback for legacy data stored as bare filenames
  if (!path.includes('/') && !path.includes('\\')) {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const baseUrl = apiUrl.replace(/\/api\/?$/, '');
    return `${baseUrl}/uploads/tours/${path}`;
  }

  // For any other relative path, return as-is
  return path;
};

/**
 * Returns a fallback image URL when the actual image is missing or fails to load.
 * Placeholder image service URL (free, no auth required).
 */
export const FALLBACK_IMAGE = 'https://placehold.co/400x300/e2e8f0/64748b?text=No+Image';